export class Store {
	_id: string;
	storeNumber: string;
	storeName: string;
	dateAdded: string;
	dateUpdated: string;
	address: string;
	address2: string;
	city: string;
	state: string;
	zip: string;
	phone: string;
	fax: string;
  email: string;
  website: string;
  taxId: string;
  salesTaxRate: number;
  dispensaryName: string;
  ipAddresses: string[];
  headerColor: string;
  abbreviation: string;
  invoicePrefix: string;
  squareDeviceId?: string;

  constructor() {
    this._id = '';
    this.storeNumber = '';
    this.storeName = '';
		this.dateAdded = '';
		this.dateUpdated = '';
		this.address = '';
		this.address2 = '';
		this.city = '';
		this.state = '';
		this.zip = '';
		this.phone = '';
		this.fax = '';
		this.email = '';
    this.website = '';
    this.taxId = '';
    this.salesTaxRate = 0;
    this.dispensaryName = '';
		this.ipAddresses = [];
		this.headerColor = '';
    this.abbreviation = '';
    this.invoicePrefix = '';
  }

}